module.exports = __webpack_public_path__ + "static/media/help_center_Icon.6e4740be.svg";